module.exports = __webpack_public_path__ + "img/holcim.6eef38d8.png";